import GeoJSON from "ol/format/GeoJSON.js";
import { createEmpty, extend } from "ol/extent";
import apiClient from "./Api";

const get_aoi_extent = async (filtroCQL) => {
  try {
    const capaWFS = process.env.REACT_APP_GEOSERVER_LAYER_AOI;
    // console.log("capaWFS", capaWFS);
    // console.log("process.env", process.env);
    // const layer = capaWFS.split(":")[1]
    const wfsUrl =
      `/geoserver/private/ows?service=WFS&version=2.0.0&request=GetFeature&outputFormat=application/json&srsname=EPSG:4326&typeName=` +
      capaWFS +
      `&CQL_FILTER=${filtroCQL}`;

    const response = await apiClient.get(wfsUrl);
    const data = response.data;

    const features = new GeoJSON().readFeatures(data, {
      dataProjection: "EPSG:4326",
      featureProjection: "EPSG:4326",
    });

    const extent = createEmpty();
    features.forEach((feature) => {
      extend(extent, feature.getGeometry().getExtent());
    });

    return extent;
  } catch (error) {
    console.error("Error al obtener las características WFS:", error);
    return null;
  }
};
export { get_aoi_extent };
